<template>
    <div class="contact">
        <div class="top">
            <div class="title">Contact Us</div>
        </div>
        <div class="img-con">
            <!-- <div class="title">公司介绍</div> -->
            <el-carousel id="contact1" class="carousel" :interval="4000" :type="swiperType" height="337px">
                <el-carousel-item v-for="item in 22" :key="item">
                    <el-image class="img" :src="require('../../assets/contact/en' + item + '.jpg')" fit="cover"
                        :preview-src-list="[require('../../assets/contact/en' + item + '.jpg')]">
                    </el-image>
                </el-carousel-item>
            </el-carousel>
        </div>
        <div class="zhuan">
            <div class="title">专业认证板</div>
            <div class="lists" id="contact2">
                <div class="list">
                    <img src="../../assets/contact/zhuan1.png" alt="">
                    <p>Migration Institute of Australia</p>
                </div>
                <div class="list">
                    <img src="../../assets/contact/zhuan2.png" alt="">
                    <p>Migration Alliance</p>
                </div>
                <div class="list">
                    <img src="../../assets/contact/zhuan3.png" alt="">
                    <p>MARA Registration Number</p>
                </div>
            </div>
        </div>
        <div class="boss">
            <div class="title">Job Recruitment</div>
            <div class="lists" id="contact3">
                <div class="list" @click="toBossFn(item)" v-for="item in jobList">
                    <div class="name">{{ item.news_title }}
                        <span class="money">{{ item.accessory }}/月</span>
                    </div>
                    <div class="base">
                        <span>Location：</span><b>{{ item.source }}</b>
                        <span>Experience：</span><b>{{ item.writer }}</b>
                        <span>Education Level：</span><b>{{ item.seo_title }}</b>
                    </div>
                </div>
                <!-- <div class="describe">
                        <p>职位描述：</p>
                        <el-tooltip class="item"> 
                            <div slot="content">
                                <div v-html="item.news_content">
                                </div>
                            </div>
                            <div class="html u-line-4" v-html="item.news_content">
                            </div>
                        </el-tooltip>
                    </div> -->
            </div>
        </div>
        <div class="feedback">
            <div class="title">Customer Feedback</div>
            <div class="lists" id="contact4">
                <div class="list" v-for="item in suggestList">
                    <div class="tops">
                        <img src="../../assets/contact/feedback.png" alt="">
                        <div class="name">
                            <p>{{ item.news_title }}</p>
                            <el-rate v-model="item.hit" :colors="colors" disabled></el-rate>
                        </div>
                    </div>
                    <!-- <div class="text">{{ item.news_about }}</div> -->
                    <!-- <img class="text" :src="item.image_url" alt=""> -->
                    <el-image fit="contain" style="width: 100%; height: auto" :src="item.image_url"
                        :preview-src-list="[item.image_url]">
                    </el-image>
                </div>
            </div>

            <el-pagination style="margin: 20px auto 0;display: flex;align-items: center;justify-content: center;"
                v-model:current-page="sugPage" v-model:page-size="sugPagesize" background border
                layout="prev, pager, next" :total="sugTotal" @current-change="sugChange" />
        </div>
        <div class="complaint">
            <div class="title">Complaint Channel</div>
            <el-form :model="suggestionInfo" :rules="suggestionrules" ref="suggestForm" label-width="100px"
                class="form-ruleForm" id="contact5">
                <el-form-item label="Name/Nickname" prop="news_title">
                    <el-input v-model="suggestionInfo.news_title"></el-input>
                </el-form-item>
                <el-form-item label="Rating" prop="hit">
                    <el-rate v-model="suggestionInfo.hit" :colors="colors"></el-rate>
                </el-form-item>
                <el-form-item label="Phone">
                    <el-input v-model="suggestionInfo.source"></el-input>
                </el-form-item>
                <el-form-item label="Email">
                    <el-input v-model="suggestionInfo.writer"></el-input>
                </el-form-item>
                <el-form-item label="Complaint Content" prop="news_about">
                    <el-input type="textarea" v-model="suggestionInfo.news_about"></el-input>
                </el-form-item>
                <el-form-item label="">
                    <el-button type="primary" @click="suggestionFn('suggestForm')">Submit</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="left-aside" @click="dialogVisible = true"><span>Click</span> <span>to</span> <span>contact</span>
            <span>us</span></div>
        <el-dialog title="Contact Us Now" :visible.sync="dialogVisible" width="60%">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                <el-form-item label="First Name" prop="name">
                    <el-input v-model="ruleForm.name"></el-input>
                </el-form-item>
                <el-form-item label="Last Name" prop="name1">
                    <el-input v-model="ruleForm.name1"></el-input>
                </el-form-item>
                <el-form-item label="Phone" prop="mobile">
                    <el-input v-model="ruleForm.mobile"></el-input>
                </el-form-item>
                <el-form-item label="Email" prop="email">
                    <el-input v-model="ruleForm.email"></el-input>
                </el-form-item>
                <el-form-item label="Appointment Service" prop="source">
                    <el-select v-model="ruleForm.source" placeholder="Please select appointment service">
                        <el-option label="Studying Abroad (Australia)" value="留学申请(澳大利亚)"></el-option>
                        <el-option label="Studying Abroad (New Zealand)" value="留学申请(新西兰)"></el-option>
                        <el-option label="Skilled independent Visa" value="技术移民"></el-option>
                        <el-option label="Skills in Demand Visa" value="雇主担保"></el-option>
                        <el-option label="Partner Visa" value="配偶移民"></el-option>
                        <el-option label="Contributory/Parent Visa" value="父母移民"></el-option>
                        <el-option label="National Innovation Visa" value="NIV(国家创新签证)及投资移民"></el-option>
                        <el-option label="155 Resident Return Visa" value="居民返程(155)签证"></el-option>
                        <el-option label="Other Visa(600,407,485,500,590 etc.)"
                            value="其他签证(600,407,485,500,590等)"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="Message" prop="message">
                    <el-input type="textarea" v-model="ruleForm.about"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submitForm('ruleForm')">Submit</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            value2: 4,
            colors: ['#99A9BF', '#F7BA2A', '#FF9900']  // 等同于 { 2: '#99A9BF', 4: { value: '#F7BA2A', excluded: true }, 5: '#FF9900' }
            ,
            con: `
             `,
            swiperType: "",
            dialogVisible: false,
            ruleForm: {
                name: '',
                name1: '',
                mobile: '',
                email: '',
                source: '技术移民',
                title: "",
                type_id: 2,
                about: '',// 留言
            },
            rules: {
                name: [
                    { required: true, message: '请输入姓', trigger: 'blur' },
                    { min: 1, max: 5, message: '长度在 1 到 5 个字符', trigger: 'blur' }
                ],
                name1: [
                    { required: true, message: '请输入名', trigger: 'blur' },
                    { min: 1, max: 5, message: '长度在 1 到 5 个字符', trigger: 'blur' }
                ],
                mobile: [
                    { required: true, message: '请输入电话', trigger: 'blur' },
                ],
                email: [
                    { required: true, message: '请输入邮箱', trigger: 'blur' },
                ],
                source: [
                    { required: true, message: '请选择预约服务', trigger: 'change' },
                ],
            },
            jobList: [],
            suggestionInfo: {
                news_title: '',
                hit: '',
                source: '',
                writer: '',
                news_about: '',
                type_id: 857
            },
            suggestionrules: {
                news_title: [
                    { required: true, message: '请输入姓名/昵称', trigger: 'blur' },
                    { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' }
                ],
                hit: [
                    { required: true, message: '请选择评分', trigger: 'blur' },
                ],
                news_about: [
                    { required: true, message: '请输入内容', trigger: 'blur' },
                    { min: 1, max: 500, message: '长度在 1 到 500 个字符', trigger: 'blur' }
                ],
            },
            sugPage: 1,
            sugPagesize: 6,
            suggestList: [],
            sugTotal: 0
        }

    },
    watch: {
        '$route.query.currentNav': function (val) {
            console.log(val, 'val')
            this.scrollIntoView('contact' + val)
        }
    },
    mounted() {
        this.handleScreenResize()
        this.getJobFn()
        this.getSuggestFn()
        window.addEventListener('resize', this.handleScreenResize)
        if (this.$route.query.currentNav) {
            this.scrollIntoView('contact' + this.$route.query.currentNav)

        }
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleScreenResize)
    },
    methods: {
        toBossFn(item) {
            this.$router.push('/en/bossDetail?news_id=' + item.news_id)
        },
        // 根据导航点击，滚动到对应位置
        scrollIntoView(id) {
            this.$nextTick(() => {
                const element = document.getElementById(id);
                console.log(element.offsetTop, 'element')
                // 元素在屏幕中间位置
                if (element) {
                    window.scrollTo({
                        top: element.offsetTop + 200,
                        behavior: 'smooth' // 平滑滚动
                    });
                }

                // if (element) {
                // element.scrollIntoView({
                //     behavior: 'smooth',
                //     block: 'top'
                // });
                // }
            })
        },
        sugChange(val) {
            this.sugPage = val;
            this.getSuggestFn()
        },
        getSuggestFn() {
            this.$http.complaint_list({
                page: this.sugPage,
                pagesize: this.sugPagesize,
                type_id: 858
            }).then(res => {
                this.suggestList = res.data || [];
                this.sugTotal = Number(res.count)
            })
        },
        suggestionFn(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (this.suggestionInfo.hit <= 0) {
                        this.$message.error('请选择评分');
                        return;
                    }
                    this.$http.complaint_add(this.suggestionInfo).then(res => {
                        if (res.code == 200) {
                            this.$message.success('提交成功');
                            this.suggestionInfo = {
                                news_title: '',
                                hit: '',
                                source: '',
                                writer: '',
                                news_about: '',
                                type_id: 857
                            }
                            this.getSuggestFn()
                        } else {
                            this.$message.error(res.msg);
                        }
                    })
                }
            })
        },
        getJobFn() {
            this.$http.job_list({
                type_id: 856
            }).then(res => {
                this.jobList = res.data || [];
                console.log(res.data, '---')
            })
        },
        handleScreenResize() {
            this.screenWidth = window.innerWidth
            if (this.screenWidth <= 600) {
                this.swiperType = ''
            } else {
                this.swiperType = 'card'
            }
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (!this.validateEmail(this.ruleForm.email)) {
                        this.$message.error('请填写正确的邮箱');
                        return;
                    }
                    this.ruleForm.title = this.ruleForm.name + this.ruleForm.name1;
                    this.$http.message_add(this.ruleForm).then(res => {
                        if (res.code == 200) {
                            this.$message.success('提交成功');
                            this.resetForm(formName);
                            this.dialogVisible = false;
                        } else {
                            this.$message.error(res.msg);
                        }
                    })
                }
            });
        },
        validateEmail(email) {
            // 定义邮箱验证正则
            const emailReg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            // 先判断是否为字符串，避免非字符串类型传入报错
            if (typeof email !== 'string') return false;
            // 使用 test 方法验证，返回布尔值
            return emailReg.test(email.trim());
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
            this.ruleForm.title = '';
        }
    }
}
</script>

<style lang="less" scoped>
.contact {
    .left-aside {
        z-index: 999;
        position: fixed;
        left: 120px;
        top: 250px;
        background-color: #222222;
        width: 50px;
        padding: 10px 0 20px;
        height: auto;
        text-align: center;
        font-size: 20px;
        font-weight: 500;
        border-radius: 5px;
        color: #fff;
        box-shadow: 0 0 10px #999;
        letter-spacing: 3px;
        // 添加呼吸动画
        animation: breathe 1.8s infinite;
        transition: .3s all;
        cursor: pointer;

        span {
            font-size: 14px;
            color: #fff;
            letter-spacing: 0;
        }
    }

    @keyframes breathe {
        0% {
            transform: scale(1);
        }

        50% {
            transform: scale(1.1);
        }

        100% {
            transform: scale(1);
        }
    }

    .zhuan {
        padding: 100px 0 100px;
        margin-bottom: 80px;

        .title {
            font-size: 40px;
            font-weight: 600;
            color: #222222;
            text-align: center;
            margin-bottom: 80px;
        }

        .lists {
            display: flex;
            max-width: 1200px;
            margin: 0 auto;
        }

        .list {
            margin-bottom: 20px;
            flex: 1;
            text-align: center;
            border-radius: 10px;
            background-color: #22222231;

            img {
                width: 80%;
                height: 100%;
                object-fit: contain;
            }

            p {
                font-size: 20px;
                font-weight: 600;
                color: #222222;
                margin-top: 20px;
            }
        }

        .list:nth-of-type(2) {
            margin: 0 40px;
        }
    }

    .complaint {
        padding: 70px 0 70px;
        margin-bottom: 80px;
        // background-color: #f1f1f1;
        border-top: 1px solid #ccc;

        .el-form .el-input {
            // width: 90%;
        }

        .title {
            font-size: 40px;
            font-weight: 600;
            color: #222222;
            text-align: center;
            margin-bottom: 20px;
        }

        .el-form {
            width: 500px;
            margin: 0 auto;
            border: 1px solid #ccc;
            padding: 50px 0 20px;
            border-radius: 10px;
            padding-right: 20px;
            box-sizing: border-box;
        }

    }

    .boss {
        padding: 100px 0 100px;
        margin-bottom: 80px;
        background-color: #f1f1f1;

        .title {
            font-size: 40px;
            font-weight: 600;
            color: #222222;
            text-align: center;
            margin-bottom: 80px;
        }

        .lists {
            display: flex;
            margin: 0 auto;
            flex-wrap: wrap;
            width: 1200px;
            justify-content: space-between;
        }

        .list {
            margin-bottom: 20px;
            border-radius: 10px;
            background-color: #fff;
            padding: 15px;
            margin-right: 20px;
            box-sizing: border-box;
            width: calc(50% - 10px);
            overflow: hidden;

            * {
                list-style: none;
                // 溢出换行
                word-wrap: break-word;
                word-break: break-all;
                text-wrap-mode: wrap !important;
            }

            .describe p {
                margin-top: 10px;
            }

            .describe * {
                list-style: none;
                // 溢出换行
                word-wrap: break-word;
                word-break: break-all;
                text-wrap-mode: wrap !important;
            }
        }

        .list:nth-of-type(2n) {
            margin-right: 0;
        }

        .name {
            font-size: 18px;

            span {
                font-weight: 500;
                color: #e87127;
            }
        }

        .base {
            font-size: 16px;
            margin: 10px 0;

            span {
                font-size: 14px;
                color: #666666;
            }

            b {
                margin-right: 15px;
            }
        }

        .describe p {
            margin-top: 10px;
            font-size: 16px;
        }

        .html {
            font-size: 14px;
            color: #666;
            box-sizing: border-box;
        }
    }

    .feedback {
        padding: 70px 0 70px;
        margin-bottom: 80px;

        .title {
            font-size: 40px;
            font-weight: 600;
            color: #222222;
            text-align: center;
            margin-bottom: 80px;
        }

        .lists {
            width: 1200px;
            margin: 0 auto;
            display: flex;
            flex-wrap: wrap;
        }

        .list {
            width: calc(33% - 13px);
            margin-bottom: 20px;
            padding: 20px;
            border-radius: 10px;
            background-color: #f1f1f1;
            margin-right: 15px;
            box-sizing: border-box;

            .left {
                flex: 1;
            }
        }

        .list:nth-of-type(3n) {
            margin-right: 0;
        }

        .tops {
            display: flex;
            margin-bottom: 10px;
        }

        .tops img {
            width: 60px;
            height: 60px;
            border-radius: 50%;
            margin-right: 20px;
        }

        .tops p {
            font-size: 18px;
            font-weight: 600;
            color: #222222;
        }

        .tops span {
            font-size: 14px;
            color: #666666;
        }

        .bottom {
            margin-top: 20px;
            font-size: 16px;
            color: #222222;
        }

        .text {
            width: 100%;
            height: auto;
        }

    }

    .img-con {
        padding: 50px 0;
        background-color: #222222;

        .title {
            font-size: 40px;
            font-weight: 600;
            color: #fff;
            text-align: center;
            margin-bottom: 80px;
        }

        .img {
            // width: 100%;
            width: 600px !important;
            height: 337px;
        }

    }

    .carousel {
        max-width: 1200px;
        margin: 0 auto;
    }

    .img-con {
        padding: 50px 0;
        background-color: #222222;

        .title {
            font-size: 40px;
            font-weight: 600;
            color: #fff;
            text-align: center;
            margin-bottom: 80px;
        }

        .img {
            width: 100%;
            height: 100%;
            object-fit: contain;
        }
    }

    /deep/.el-carousel__mask {
        background-color: transparent;
    }


    .top {
        width: 100vw;
        height: 300px;
        position: relative;
        overflow: hidden;
        background-image: url('../../assets/imgs/concat_us.png');
        background-size: 100% auto;
        transition: .3s all;
        background-position: top center;

        .title {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: 60px;
            font-weight: 600;
            letter-spacing: 2px;
            color: #222222;
            text-shadow: 3px 3px 5px #fff;
        }



        img {
            width: 100%;
            object-fit: cover;
            height: 100%;
            transition: .3s all;
        }

        &:hover {
            background-size: 110% auto;

            img {
                transform: scale(1.1);
            }
        }
    }

}


@media (max-width: 899px) {
    .contact {
        .top {
            height: 200px;

            .title {
                font-size: 30px;
                width: 100%;
                text-align: center;
                padding: 0 20px;
                box-sizing: border-box;
            }
        }

        .left-aside {
            left: 10px;
            width: 40px;
            font-size: 16px;
            padding: 8px 0 15px;

            span {
                font-size: 12px;
            }
        }

        .img-con {
            padding: 30px 0;

            .title {
                font-size: 24px;
                margin-bottom: 30px;
            }

            .img {
                width: 100%;
                height: auto;
            }
        }

        .zhuan {
            padding: 60px 0 60px;
            margin-bottom: 40px;

            .title {
                font-size: 30px;
                margin-bottom: 40px;
            }

            .lists {
                display: block;
                padding: 0 20px;
                box-sizing: border-box;
            }

            .list {
                margin: 0 0 20px;
                padding: 15px;

                img {
                    width: 80%;
                    height: auto;
                }

                p {
                    font-size: 16px;
                    margin-top: 15px;
                }
            }

            .list:nth-of-type(2) {
                margin: 0 0 20px;
            }
        }

        .boss {
            padding: 60px 0;
            margin-bottom: 40px;

            .title {
                font-size: 30px;
                margin-bottom: 40px;
            }

            .lists {
                width: calc(100% - 30px);
                padding: 0 15px;
                box-sizing: border-box;

                .list {
                    width: 100%;
                    margin-right: 0;
                    margin-bottom: 15px;
                    padding: 12px;

                    .name {
                        font-size: 16px;
                    }

                    .base {
                        font-size: 14px;
                        margin: 8px 0;

                        span {
                            font-size: 12px;
                        }

                        b {
                            margin-right: 10px;
                        }
                    }
                }
            }
        }

        .feedback {
            padding: 50px 0 50px;
            margin-bottom: 40px;

            .title {
                font-size: 30px;
                margin-bottom: 40px;
            }

            .lists {
                width: calc(100% - 40px);
                padding: 0 20px;
                box-sizing: border-box;

                .list {
                    width: 100%;
                    margin-right: 0;
                    margin-bottom: 15px;
                    padding: 15px;

                    .tops img {
                        width: 50px;
                        height: 50px;
                        margin-right: 15px;
                    }

                    .tops p {
                        font-size: 16px;
                    }
                }
            }
        }

        .complaint {
            padding: 50px 0 50px;
            margin-bottom: 40px;

            .title {
                font-size: 30px;
                margin-bottom: 30px;
            }

            .el-form {
                width: calc(100% - 40px);
                margin: 0 auto;
                padding: 30px 15px 15px;

                /deep/.el-form-item {
                    margin-bottom: 15px;

                    label {
                        font-size: 14px;
                    }

                    .el-input__inner {
                        font-size: 14px;
                    }
                }
            }
        }

        .carousel {
            max-width: 100%;
        }
    }

    /deep/.el-dialog {
        width: 90% !important;
    }

    /deep/.el-carousel__container {
        height: 250px !important;
    }

    /deep/.el-carousel__button {
        width: 3px !important;
    }
}

/* 响应式适配：小屏幕设备 */
@media (max-width: 480px) {
    .contact {
        .top {
            height: 160px;

            .title {
                font-size: 24px;
                padding: 0 15px;
            }
        }

        .left-aside {
            left: 5px;
            width: 35px;
            font-size: 14px;
            padding: 6px 0 12px;

            span {
                font-size: 10px;
            }
        }

        .img-con {
            padding: 20px 0;

            .title {
                font-size: 20px;
                margin-bottom: 20px;
            }
        }

        .zhuan {
            padding: 40px 0 40px;
            margin-bottom: 30px;

            .title {
                font-size: 24px;
                margin-bottom: 30px;
            }

            .list {
                padding: 10px;

                p {
                    font-size: 14px;
                    margin-top: 10px;
                }
            }
        }

        .boss {
            padding: 40px 0 40px;
            margin-bottom: 30px;

            .title {
                font-size: 24px;
                margin-bottom: 30px;
            }

            .lists {
                width: calc(100% - 20px);
                padding: 0 10px;

                .list {
                    padding: 10px;

                    .name {
                        font-size: 14px;
                    }

                    .base {
                        font-size: 12px;

                        b {
                            margin-right: 8px;
                        }
                    }
                }
            }
        }

        .feedback {
            padding: 40px 0 40px;
            margin-bottom: 30px;

            .title {
                font-size: 24px;
                margin-bottom: 30px;
            }

            .lists {
                width: calc(100% - 30px);
                padding: 0 15px;

                .list {
                    padding: 12px;

                    .tops img {
                        width: 40px;
                        height: 40px;
                        margin-right: 10px;
                    }

                    .tops p {
                        font-size: 14px;
                    }
                }
            }
        }

        .complaint {
            padding: 40px 0 40px;
            margin-bottom: 30px;

            .title {
                font-size: 24px;
                margin-bottom: 20px;
            }

            .el-form {
                width: calc(100% - 30px);
                padding: 20px 10px 10px;

                /deep/.el-form-item {
                    margin-bottom: 12px;

                    label {
                        font-size: 13px;
                    }

                    .el-input__inner {
                        font-size: 13px;
                    }
                }

                /deep/.el-button {
                    font-size: 13px;
                }
            }
        }
    }

    /deep/.el-carousel__container {
        height: 200px !important;
    }
}
</style>


// WEBPACK FOOTER //
// src/views/en/contactUs.vue